<div class="progress-bar">
	<span class="bar">
		<span class="progress"></span>
	</span>
</div>
